module.exports = __webpack_public_path__ + "static/media/C_E01.0a8ea01f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_E01.png
// module id = 94
// module chunks = 0